import { useEffect, useState } from 'react';
import { isNextUpEnabled, isTransitionWarningEnabled } from '@/utils/npfNudges';

/**
 * Live-läsning av NPF-nudge-flaggorna (Pipeline 3). Samma mönster som
 * useEffectiveChildMode/useActivePersona: initieras via getters och prenumererar
 * på 'storage'-eventet så att en ändring i inställningarna slår igenom direkt utan
 * omladdning (setterna i npfNudges dispatchar 'storage' i samma flik).
 */
export const useNpfNudgePrefs = (): {
  nextUpEnabled: boolean;
  transitionWarningEnabled: boolean;
} => {
  const [nextUpEnabled, setNextUpEnabled] = useState<boolean>(isNextUpEnabled());
  const [transitionWarningEnabled, setTransitionWarningEnabled] = useState<boolean>(
    isTransitionWarningEnabled(),
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setNextUpEnabled(isNextUpEnabled());
      setTransitionWarningEnabled(isTransitionWarningEnabled());
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return { nextUpEnabled, transitionWarningEnabled };
};
